define('controller/disclosure/disclosure.reporting.controller',['require','exports','module','fukit','backbone.radio','view/reporting/reporting.view','underscore','fukit'],function(require, exports, module) {
  //prettier-ignore
  var BaseController        = require('fukit').BaseController,
    Radio                   = require('backbone.radio'),
    ReportingView           = require('view/reporting/reporting.view'),
    _                       = require('underscore'),
    ROLES                   = require('fukit').Roles;

  var  coiModel;
  var  productNewCoiUiValue = false;
  const enabledProductCollection =   Radio.request(
      'AppKit.resourceService',
      'resource',
      'enabledProductCollection'
  );

  if (!_.isUndefined(enabledProductCollection)) {
    coiModel = enabledProductCollection.findWhere({name: 'COI', active: true});
    const dataModel = coiModel.collection.models;
    const filteredDataArray = dataModel.filter(function (item) {
      return item.attributes.name === "COI" && item.attributes.active === true;
    });
    productNewCoiUiValue = filteredDataArray[0].attributes.productNewCoiUi;
  }

  if(productNewCoiUiValue){
    localStorage.setItem("productNewCoiUiValue", productNewCoiUiValue.toString());
    location.assign(location.origin + '/coi-react/reporting');
  }

  var ReportingController = BaseController.extend({
    radioRequests: {
      'controllers ReportingController': '@constructor',
    },

    pageView: ReportingView,

    stateConfiguration: {
      defaults: {
        roles: ROLES.GLOBALACCESSROLES,
      },
    },

    resources: {
      // Utility resource
      uiState: {
        model: Backbone.Model.extend({
          defaults: {
            disableLinkButton: true,
            userLinked: false,
            userPending: false,
            sidebarLoading: false,
            emailActionSuccess: false,
            emailActionNotify: false,
          },
        }),
      },
    },

    onStart: function() {
    }
  });

  module.exports = ReportingController;
});

